// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__I524o","collapse":"styles_collapse__jRvSJ","button":"styles_button__v23kQ","heading":"styles_heading__0nXIb"};